import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const SplashScreen = ({ onComplete }) => {

    useEffect(() => {
        // Ensure onComplete is called
        const timer = setTimeout(() => {
            if (onComplete) onComplete();
        }, 2500);
        return () => clearTimeout(timer);
    }, [onComplete]);

    return (
        <motion.div
            className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white dark:bg-[#00152E]"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            {/* Logo Animation */}
            <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="relative mb-6"
            >
                <div className="w-24 h-24 bg-gradient-to-br from-indigo-600 to-indigo-700 rounded-3xl flex items-center justify-center shadow-2xl shadow-indigo-200 dark:shadow-none transform rotate-3">
                    <span className="text-5xl font-bold text-white">S</span>
                </div>
                <div className="absolute inset-0 bg-indigo-400 rounded-3xl -rotate-6 -z-10 opacity-30 blur-sm"></div>
            </motion.div>

            <motion.div
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.4 }}
                className="text-center"
            >
                <h1 className="text-3xl font-bold text-slate-800 dark:text-white tracking-tight">Smaart Institute</h1>
                <p className="text-slate-500 dark:text-slate-300 mt-2 font-medium">Phygital Learning Platform</p>
            </motion.div>

            <motion.div
                className="mt-12 w-48 h-1.5 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden relative"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6 }}
            >
                <motion.div
                    className="absolute inset-0 bg-gradient-to-r from-indigo-500 to-indigo-600 rounded-full"
                    initial={{ x: '-100%' }}
                    animate={{ x: '100%' }}
                    transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
                />
            </motion.div>
        </motion.div>
    );
};

export default SplashScreen;
